import script from "./WapStudentView.vue?vue&type=script&lang=ts&setup=true"
export * from "./WapStudentView.vue?vue&type=script&lang=ts&setup=true"

import "./WapStudentView.vue?vue&type=style&index=0&id=623dbf19&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-623dbf19"]])

export default __exports__